module.exports = __webpack_public_path__ + "assets/TransactionDetails.199bc76c.svg";